/** Create audio (ADR 0028): what the server spoke, as a voice note the draft takes. */
import type { CreatedAudio } from '../api/client';

/** Longest line the server takes (backend/routes/audio.py MAX_CREATE_TEXT). */
export const MAX_CREATE_TEXT = 600;

export interface CreatedVoiceNote {
  file: File;
  url: string;
  seconds: number;
  recordingId: number | null;
}

/** The mp3 the server spoke, as a file the voice-note upload takes. */
export function voiceNoteFile(audio: CreatedAudio): CreatedVoiceNote {
  const bytes = Uint8Array.from(atob(audio.audio_b64), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: audio.mime || 'audio/mpeg' });
  const file = new File([blob], `voice-${Date.now()}.mp3`, { type: blob.type });
  return { file, url: URL.createObjectURL(blob), seconds: Math.max(1, Math.round(audio.duration_s)), recordingId: audio.recording_id };
}
